import { SurveyProvider } from "../../models/survey"

export const SURVEY_URL_PREFIXES = {
  [SurveyProvider.typeform]: "https://aworld.typeform.com/to/",
  [SurveyProvider.qualtrics]: "https://aworld.qualtrics.com/jfe/form/"
} as const
